import {Button, Group, Input, Stack, TextInput, createStyles} from '@mantine/core';
import {useId} from '@mantine/hooks';
import React, {useState} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import StudySearchInput, {getStudyIds, useStudySearchControlledItemsProps} from 'studies/StudySearchInput';
import type {RunModalProps} from 'ui-library/runModal';

const useStyles = createStyles((theme) => ({
  footer: {
    borderTop: `1px solid ${theme.colors.gray[3]}`,
    paddingTop: theme.spacing.md,
    marginTop: theme.spacing.lg,
  },
}));

export interface SubmitReactionModalResult {
  reactionName: string;
  folderId: string;
  studyIds: Array<string>;
}

export type SubmitReactionModalProps = RunModalProps<SubmitReactionModalResult>;

export default function SubmitReactionModal({close}: SubmitReactionModalProps): JSX.Element {
  const {classes} = useStyles();
  const [reactionName, setReactionName] = useState('');
  const [folderId, setFolderId] = useState<string | null>(
    FolderDefaults.get(FolderDefaultsKey.NOTEBOOK) ?? null
  );

  const studySearchProps = useStudySearchControlledItemsProps([]);
  const studySearchInputId = useId();

  const canSubmit = reactionName.trim().length > 0 && folderId != null;

  return (
    <>
      <Stack spacing="md">
        <TextInput
          autoFocus={true}
          label="Reaction name"
          onChange={(e) => {
            setReactionName(e.currentTarget.value);
          }}
          placeholder="Name"
          required={true}
          value={reactionName}
        />
        <Input.Wrapper label={DEFAULT_PROJECT_FOLDER_LABEL_TEXT} required={true}>
          <FolderSelector
            enableRedesign={true}
            onChange={(e) => {
              setFolderId(e.target.value);
            }}
            showNotebook={true}
            unsetOnFetchFail={true}
            value={folderId}
          />
        </Input.Wrapper>
        {BenchlingConfig.STUDIES_ENABLE && (
          <Input.Wrapper id={studySearchInputId} label="Studies">
            <StudySearchInput
              id={studySearchInputId}
              onChange={studySearchProps.onChange}
              selectedItems={studySearchProps.selectedItems}
              shouldAllowMultiple={true}
            />
          </Input.Wrapper>
        )}
      </Stack>
      <Group position="right" className={classes.footer}>
        <Button variant="ghost" onClick={() => close()}>
          Cancel
        </Button>
        <Button
          disabled={!canSubmit}
          onClick={() => {
            close({
              reactionName: reactionName.trim(),
              folderId: folderId!,
              studyIds: BenchlingConfig.STUDIES_ENABLE ? getStudyIds(studySearchProps) : [],
            });
          }}
        >
          Submit
        </Button>
      </Group>
    </>
  );
}
